import { Injectable } from "@angular/core";
import { AuthenticationData } from "../auth-data/auth-data";

/**
 * This class abstracts local storage usage for user authentication data.
 */
@Injectable({
  providedIn: "root",
})
export class UserAuthenticationDataManagerService {

  static readonly USER_AUTHENTICATION_STORE_KEY = 'user-authentication-data';

  public save(user: AuthenticationData): void {
    localStorage.setItem(
      UserAuthenticationDataManagerService.USER_AUTHENTICATION_STORE_KEY,
      user.serialize())
  }

  public logOut(): void {
    localStorage.removeItem(UserAuthenticationDataManagerService.USER_AUTHENTICATION_STORE_KEY)
  }

  public retrieve(): AuthenticationData | null {
    let user: AuthenticationData | null = null;

    const serializedUser = localStorage.getItem(UserAuthenticationDataManagerService.USER_AUTHENTICATION_STORE_KEY);

    if (serializedUser) {
      user = AuthenticationData.unserialize(serializedUser);
    }
    return user;
  }
}
